import React, { useEffect } from "react";

// mui
import { Grid, styled } from "@mui/material";

// util
import { useNavigate } from "react-router";
import { viewportBelowPageHeader } from "../../../constants/pageLayout";
import WorkflowProgressView from "../WorkflowProgressView/WorkflowProgressView";

// styled components
const SessionBox = styled(Grid)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "8px",
  background: theme.palette.background.paper,
  height: viewportBelowPageHeader(16),
  overflow: "hidden",
  position: "relative",
}));

const OuterItem = styled(Grid)({
  padding: "0px 8px 0px 8px",
  height: viewportBelowPageHeader(),
  overflow: "hidden",
});

function SelectedSessionBox({ selectedSession, refreshSessions, searchText }) {
  const navigate = useNavigate();

  useEffect(() => {
    // Update the URL params accordingly
    // depending on what session is selected
    const params = new URLSearchParams(window.location.search);
    params.set("viewSession", selectedSession.projectSessionId);
    navigate({ search: params.toString() });
  }, [selectedSession]);

  return (
    <OuterItem container className="session-log-outer-item">
      <Grid item xs={12} sx={{ height: "100%" }}>
        <SessionBox container className="session-log-box">
          <WorkflowProgressView
            isSplitView
            id={selectedSession.projectId}
            project_session_id={selectedSession.projectSessionId}
            isTest={Boolean(selectedSession.projectTestId)}
            refreshSessions={refreshSessions}
            externalSearchQuery={searchText}
          />
        </SessionBox>
      </Grid>
    </OuterItem>
  );
}

export default SelectedSessionBox;
